module.exports = __webpack_public_path__ + "img/seven.f114b87d.png";